import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=119a36f9&scoped=true&"
import script from "./Offers.vue?vue&type=script&lang=ts&"
export * from "./Offers.vue?vue&type=script&lang=ts&"
import style0 from "./Offers.vue?vue&type=style&index=0&id=119a36f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a36f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('119a36f9')) {
      api.createRecord('119a36f9', component.options)
    } else {
      api.reload('119a36f9', component.options)
    }
    module.hot.accept("./Offers.vue?vue&type=template&id=119a36f9&scoped=true&", function () {
      api.rerender('119a36f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/Offers.vue"
export default component.exports